import { EnumSchema } from '../metadata-schema';

export const VergelijkingUitstroomniveauVSO: EnumSchema = {
	"type": "string",
	"title": "VergelijkingUitstroomniveauVSO",
	"enum": [
		"Onder niveau",
		"Op niveau",
		"Boven niveau"
	]
};
